import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import { contextConnect } from '@wp-g2/context';
import React from 'react';
import { BaseChoice, useBaseChoice } from '../BaseChoice';
import RadioElement from './RadioElement';

function Radio(props, forwardedRef) {
  var _useBaseChoice = useBaseChoice(props, 'Radio'),
      baseChoice = _useBaseChoice.baseChoice,
      otherProps = _objectWithoutProperties(_useBaseChoice, ["baseChoice"]);

  return /*#__PURE__*/React.createElement(BaseChoice, baseChoice, /*#__PURE__*/React.createElement(RadioElement, Object.assign({}, otherProps, {
    ref: forwardedRef
  })));
}

export default contextConnect(Radio, 'Radio');